import request from '@/utils/request'

// 获取学员学习情况总览
export function getStudentLearningOverview(id) {
    return request({
        url: `/api/admin/student/learning/overview/${id}`,
        method: 'get'
    })
}

// 获取学员练习明细
export function getStudentPracticeDetailList(id) {
    return request({
        url: `/api/admin/student/learning/practice-list/${id}`,
        method: 'get'
    })
}

// 获取学员考试明细
export function getStudentExamDetailList(id) {
    return request({
        url: `/api/admin/student/learning/exam-list/${id}`,
        method: 'get'
    })
}

// 删除学员
export function deleteStudent(id) {
    return request({
        url: `/api/admin/student/delete/${id}`,
        method: 'delete'
    })
}

// 学员列表查询（分页）
export function getStudentList(params) {
    return request({
        url: '/api/admin/student/list',
        method: 'get',
        params
    })
}

// 新增学员
export function addStudent(data) {
    return request({
        url: '/api/admin/student/add',
        method: 'post',
        data
    })
}

// 编辑学员
export function updateStudent(data) {
    return request({
        url: '/api/admin/student/update',
        method: 'put',
        data
    })
}

// 启用/禁用学员
export function updateStudentStatus(data) {
    return request({
        url: '/api/admin/student/status',
        method: 'put',
        data
    })
}

// 重置密码
export function resetStudentPassword(username) {
    return request({
        url: `/api/admin/student/reset-password/${username}`,
        method: 'put'
    })
}

// 在线统计
export function getOnlineStatistics() {
    return request({
        url: '/api/admin/student/online/statistics',
        method: 'get'
    })
}

// 在线学员状态分页查询
export function getOnlineStudentStatusPage(params) {
    return request({
        url: '/api/admin/student/online/student-status',
        method: 'get',
        params
    })
}